import { Flex, Spacing } from '@billy/design-system'

import { SalesReportDateSelection } from './elements/SalesReportDateSelection'
import { SalesReportDisplaySettings } from './elements/SalesReportDisplaySettings'
import { SalesReportPeriodSelect } from './elements/SalesReportPeriodSelect'

export const SalesReportToolbar = () => {
  return (
    <Flex alignItems="center" gap={Spacing.S8} justifyContent="space-between">
      <Flex alignItems="center">
        <SalesReportPeriodSelect />
      </Flex>
      <Flex alignItems="center" gap={Spacing.S8}>
        <SalesReportDateSelection />
        <SalesReportDisplaySettings />
      </Flex>
    </Flex>
  )
}
